<ng-container *ngIf="input?.invalid && input?.touched" >
    <ng-container *ngIf="input.hasError('required'); else elseTemplate">
        <small class="p-error" >{{'FORM_ERRORS.required'|translate}}</small>
    </ng-container>
    <ng-template #elseTemplate>
        <span [ngSwitch]="errorType">
            <small class="p-error" *ngSwitchCase="'minlength'"> {{'FORM_ERRORS.minlength'|translate}} </small>
            <small class="p-error" *ngSwitchCase="'maxlength'">{{'FORM_ERRORS.maxlength'|translate}}</small>
            <small class="p-error" *ngSwitchCase="'emailValidation'">{{'FORM_ERRORS.email'|translate}} </small>
            <small class="p-error" *ngSwitchCase="'email'">{{'FORM_ERRORS.email'|translate}} </small>
            <small class="p-error" *ngSwitchCase="'pattern'">{{'FORM_ERRORS.pattern'|translate}} </small>
            <small class="p-error" *ngSwitchCase="'min'">{{'FORM_ERRORS.min'|translate}} </small>
            <small class="p-error" *ngSwitchCase="'max'">{{'FORM_ERRORS.max'|translate}} </small>
            <small class="p-error" *ngSwitchCase="'sinDefinir'">{{'FORM_ERRORS.sinDefinir'|translate}} </small>
            <small class="p-error" *ngSwitchCase="'listaAutocompletarValidation'">{{'FORM_ERRORS.listaAutocompletarValidation'|translate}} </small>
            <small class="p-error" *NgSwitchDefault>{{getCustomValidationLabel(errorType)|translate}}</small>
        </span>
    </ng-template>
</ng-container>
<ng-container *ngIf="form !== null && form.errors" >
        <div [ngClass]="{'p-pt-1':input.invalid && (input.touched || input.dirty)}">
            <small class="p-error">{{getCustomValidationLabel(errorTypeForm)|translate}}</small>
        </div>
</ng-container>